import { Component, OnInit } from '@angular/core';
import { RefferalDiscountService } from '../../../../services/refferal-discount.service';
import { CountriesService } from '../../../../services/countries.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DoctorBreadcrumbService } from '../../../medical-profession/shared/breadcrumb.service';
import { TraceClassDecorator } from '@sentry/angular';
import { ProviderStateService } from 'src/app/services/provider-state.service';

interface CreateDiscount {
    referral_type_id: number;
    discount_code: string;
    applies_to: number;
    max_limit: number;
    discount_percent: number;
    discount_amount: number;
    expires_at: Date;
    starts_at: Date;
    is_global: boolean;
    country_id: number;
    is_onetime: boolean;
}

interface DiscountType {
    id: number;
    referral_type: string;
    referral_prefix: string;
}

@TraceClassDecorator()
@Component({
    selector: 'app-refferal',
    templateUrl: './refferal.component.html',
    styleUrls: ['./refferal.component.css']
})
export class RefferalComponent implements OnInit {
    startDate: Date = null;
    endDate: Date = null;
    minStartDateValue: Date;
    minEndDateValue: Date;
    provider_id: string = "";
    createDiscount: CreateDiscount = {
        referral_type_id: 0,
        discount_code: '',
        applies_to: 0,
        max_limit: -1,
        discount_percent: 0,
        discount_amount: null,
        expires_at: null,
        starts_at: null,
        is_global: false,
        country_id: 0,
        is_onetime: false
    };

    refferalTypes: DiscountType[];
    discountprefix: string = null;
    refferalTypeId: number = 0;
    discountCode: string = null;
    appliesTo: number = 0;
    discountusage: number = null;
    discountPercent: number = null;
    discountAmount: null;
    dob: Date = null;
    isgblobal: boolean = false;
    countries: any[];
    selectedCountry = null;
    loading: boolean = false;
    e: any = null;
    minDateValue: Date = new Date();
    validDate: boolean = false;
    countValid: boolean = true;
    slug: string = "";

    constructor(
        private readonly refferalDiscountService: RefferalDiscountService,
        private readonly CountryService: CountriesService,
        private readonly router: Router,
        private readonly messageService: MessageService,
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly providerStateService: ProviderStateService
    ) {
        this.minStartDateValue = new Date();
        this.minEndDateValue = new Date();
    }

    async getRefferalType() {
        await this.refferalDiscountService
            .getRefferalTypes1()
            .toPromise()
            .then((resp) => {
                this.refferalTypes = resp.data.data;
            });
    }

    setPrefix(pre: string) {
        const list = pre.split('$-$@@$@@$#@$@$@$@-@', 2);
        this.refferalTypeId = parseInt(list[0]);
        this.discountprefix = list[1];
    }
    createDiscountCode() {
        this.e = null;

        if (this.refferalTypeId > 0) {
            this.createDiscount.referral_type_id = +this.refferalTypeId;
        } else {
            this.e = 'error : Select The Type Of Discount';
        }
        if (
            (this.discountprefix + this.discountCode).startsWith(
                this.discountprefix
            ) &&
            (this.discountprefix + this.discountCode).length <= 10
        ) {
            this.createDiscount.discount_code =
                this.discountprefix + this.discountCode;
        } else this.createDiscount.applies_to = this.appliesTo;

        this.createDiscount.max_limit = this.discountusage;
        this.createDiscount.is_onetime = false;
        this.createDiscount.discount_percent = +this.discountPercent;
        this.createDiscount.discount_amount = null;
        if (this.startDate != null && this.endDate != null) {
            if (this.endDate >= this.startDate) {
                this.createDiscount.expires_at = this.endDate;
                this.createDiscount.starts_at = this.startDate;
                this.validDate = true;
            } else {
                this.e = 'error : End Date should be greater than Start Date';
            }
        }
        //  this.createDiscount.expires_at = this.dob;

        this.createDiscount.is_global = this.isgblobal;

        if (this.isgblobal) {
            this.countValid = true;
            this.createDiscount.country_id = 0;
        } else if (this.selectedCountry > 0) {
            this.countValid = true;
            this.createDiscount.country_id = +this.selectedCountry;
        } else {
            this.countValid = false;
            this.e = 'error : Select the Country Status';
        }
        if (
            this.createDiscount.referral_type_id > 0 &&
            this.createDiscount.discount_code != null &&
            this.createDiscount.discount_percent > 0 &&
            this.countValid &&
            this.validDate
        ) {
            this.saveDiscountCode();
        } else {
            //this.e="Enter Valid Details"
        }
    }

    async getCountries() {
        await this.CountryService.getCountries(this.provider_id)
            .toPromise()
            .then((countries) => (this.countries = countries));
    }

    async saveDiscountCode() {
        this.loading = true;
        await this.refferalDiscountService
            .saveDiscountCode(this.createDiscount)
            .toPromise()
            .then((resp) => {
                if (resp.success) {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Saved Data',
                        detail: 'Created Code Successfully'
                    });
                    this.loading = false;
                    this.e = 'Created Code Successfully';
                } else {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: resp.error.message
                    });
                    this.loading = false;
                    this.e = resp.error.message;
                }
            })
            .catch((error) => {
                this.e = error.error.message;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.error.message
                });
                this.loading = false;
            });
        this.loading = false;
    }

    prev() {
        this.router.navigate(['/' + this.slug + '/doctor/admin/coupons']);
    }

    ngOnInit(): void {
        this.slug = this.providerStateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: 'Administration' },
            { label: 'Create Referral Code' }
        ]);
        this.provider_id = this.providerStateService.getProviderId();
        this.getRefferalType();
        this.getCountries();

    }
}
